(() => {
  'use strict';
  const formatOptions = ['Table de mezzés', 'Buffet street food', 'Cocktails & bouchées', 'brunch - petit dej', 'anniv', 'célébration'];
  function capturedText(p) {
    const clone = p.cloneNode(true);
    clone.querySelectorAll('br').forEach(br => br.replaceWith(document.createTextNode(' ')));
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }
  function fixContact(canvas) {
    if (!canvas.querySelector('.soeli-service-choice') || canvas.querySelector('.soeli-contact-body')) return;
    const section = document.createElement('section'); section.className = 'soeli-mobile-contact';
    const intro = document.createElement('div'); intro.className = 'soeli-contact-intro';
    const body = document.createElement('div'); body.className = 'soeli-contact-body';
    const paragraphs = [...canvas.querySelectorAll('p,h2,h3')].sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
    for (const p of paragraphs) {
      const text = capturedText(p);
      if (/^(demander un devis|Racontez|Quelques informations|Réponse sous|Vous préférez|Vous ne savez)/i.test(text)) {
        const item = document.createElement(/^Racontez/i.test(text) ? 'h2' : 'p');
        item.textContent = text; intro.append(item);
        if (/^Racontez/i.test(text)) {
          item.replaceChildren(document.createTextNode('Racontez nous '));
          const emphasis = document.createElement('em'); emphasis.textContent = 'votre occasion.'; item.append(emphasis);
        }
      }
    }
    const controls = [...canvas.querySelectorAll('input:not([type=hidden]):not([type=radio]),select,textarea')].filter(control => control.getAttribute('aria-label') !== 'Occasion');
    const order = ['TYPE D’ÉVÉNEMENT', 'Date souhaitée', 'Nombre de personnes', 'VILLE DE L’ÉVÉNEMENT'];
    function appendField(control) {
      const field = document.createElement('div'); field.className = 'soeli-contact-field';
      const label = document.createElement('label');
      label.textContent = control.getAttribute('aria-label') === 'email' ? 'EMAIL*' : control.getAttribute('aria-label') || control.name;
      control.removeAttribute('class'); control.removeAttribute('style');
      label.append(control); field.append(label); body.append(field);
    }
    for (const key of order) {
      const control = controls.find(c => (c.getAttribute('aria-label') || '').replace(/\*$/, '').toLowerCase() === key.toLowerCase());
      if (control) { appendField(control); controls.splice(controls.indexOf(control), 1); }
    }
    const group = document.createElement('fieldset'); group.className = 'soeli-contact-choices';
    const legend = document.createElement('legend'); legend.textContent = 'NIVEAU DE SERVICE SOUHAITÉ*'; group.append(legend);
    for (const existing of canvas.querySelectorAll('.soeli-service-choice')) {
      const label = document.createElement('label'); label.className = 'soeli-service-choice';
      const input = existing.querySelector('input'); if (!input) continue;
      const copy = document.createElement('span'); copy.textContent = input.value;
      const detail = document.createElement('small');
      detail.textContent = {'Livraison':'Prêt à servir','Livraison & mise en place':'Buffet installé','Sur mesure':'Accompagnement complet'}[input.value] || '';
      copy.append(detail); label.append(input, copy); group.append(label);
    }
    body.append(group);
    const format = document.createElement('select'); format.name = 'contact[Format envisagé]'; format.setAttribute('aria-label', 'Format envisagé');
    for (const value of formatOptions) format.add(new Option(value, value));
    appendField(format);
    controls.sort((a,b) => {
      const order = ['BUDGET INDICATIF','email','Téléphone','Message'];
      return order.indexOf(a.getAttribute('aria-label')) - order.indexOf(b.getAttribute('aria-label'));
    });
    for (const control of controls) appendField(control);
    const submit = canvas.querySelector('button[type=submit]');
    if (submit) { submit.removeAttribute('class'); body.append(submit); }
    for (const status of canvas.querySelectorAll('.soeli-canva-error')) body.append(status);
    section.append(intro, body); canvas.replaceChildren(section);
  }
  function fixCards(canvas) {
    const frame = canvas.closest('.soeli-canva-frame');
    canvas.querySelectorAll('[data-card^="btn:"]').forEach(label => {
      if (label.querySelector('[data-canva-purchase], .soeli-product-form')) return;
      const key = label.dataset.card;
      const counterpart = frame?.querySelector('[data-canva-width="390"] [data-card="' + key + '"]');
      const mobileForm = counterpart?.querySelector('.soeli-product-form');
      const title = canvas.querySelector('[data-card="title:' + key.split(':')[1] + '"]');
      if (!mobileForm) {
        if (/^(AJOUTER|AJOUTER AU PANIER)$/.test(label.textContent.trim())) {
          const disabled = document.createElement('span'); disabled.setAttribute('aria-disabled', 'true'); disabled.textContent = 'Indisponible'; label.replaceChildren(disabled);
        }
        return;
      }
      const variants = mobileForm.querySelector('select[name=id]');
      const single = mobileForm.querySelector('input[name=id]');
      const choices = variants ? [...variants.options].map(o => ({ id: o.value, title: o.textContent, available: !o.disabled })) : single ? [{ id: single.value, title: title?.textContent.trim() || '', available: !mobileForm.querySelector('button:disabled') }] : [];
      if (!choices.length) return;
      const button = document.createElement('button'); button.type = 'button'; button.className = 'soeli-canva-cover-button';
      button.dataset.canvaPurchase = ''; button.dataset.productTitle = title?.textContent.trim() || '';
      button.dataset.productVariants = JSON.stringify(choices);
      button.textContent = label.textContent.trim() || (choices.length > 1 ? 'Choisir' : 'Ajouter');
      button.disabled = !choices.some(v => v.available); label.replaceChildren(button);
    });
    canvas.querySelectorAll('[data-card^="title:"]').forEach(title => {
      title.style.whiteSpace = 'normal';
      title.querySelectorAll('span').forEach(span => { span.style.whiteSpace = 'normal'; span.style.fontSize = 'inherit'; });
      let size = parseFloat(getComputedStyle(title).fontSize);
      const max = title.closest('[lang]')?.parentElement;
      if (!max) return;
      while (title.scrollHeight > Math.max(48, max.clientHeight) && size > 18) { size -= 1; title.style.fontSize = size + 'px'; }
    });
  }
  // Keep captured headings and button labels inside their Canva boxes when web fonts render wider.
  function fitText(canvas) {
    canvas.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(h => {
      if (h.closest('.soeli-mobile-contact,details')) return;
      const box = h.offsetHeight; if (!box || h.scrollHeight <= box + 3) return;
      let size = parseFloat(getComputedStyle(h).fontSize); const min = size * 0.72;
      h.querySelectorAll('span').forEach(s => { s.style.fontSize = 'inherit'; });
      while (h.scrollHeight > box + 3 && size > min) { size -= 0.5; h.style.fontSize = size + 'px'; }
    });
  }
  // Canva exports a button as two unrelated nodes: a painted shape and a floating text.
  // Snap each control (button, link, input) onto the painted shape behind it and centre
  // it with flexbox, so labels are always centred and never clipped by the shape edges.
  const alpha = c => { const m = c && c.match(/rgba?\(([^)]+)\)/); if (!m) return 0; const v = m[1].split(/[ ,/]+/).filter(Boolean); return v.length > 3 ? parseFloat(v[3]) : 1; };
  function painted(el) {
    if (el.tagName.toLowerCase() === 'svg') return !!el.querySelector('path,rect,ellipse,circle,polygon');
    if (el.querySelector('p,img,svg,input,button')) return false;
    const cs = getComputedStyle(el);
    return alpha(cs.backgroundColor) > 0 || cs.backgroundImage !== 'none' || (parseFloat(cs.borderTopWidth) > 0 && alpha(cs.borderTopColor) > 0);
  }
  function shapeBehind(canvas, label, rect) {
    const cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2, area = Math.max(rect.width * rect.height, 1);
    let best = null, bestArea = Infinity;
    for (const el of canvas.querySelectorAll('div,svg')) {
      if (el.contains(label) || label.contains(el) || el.closest('svg') !== null && el.tagName.toLowerCase() !== 'svg') continue;
      const r = el.getBoundingClientRect(), a = r.width * r.height;
      if (cx < r.left || cx > r.right || cy < r.top || cy > r.bottom || a < area * 0.9 || a > area * 14 || a >= bestArea || r.width < rect.width - 2) continue;
      if (!painted(el)) continue;
      best = el; bestArea = a;
    }
    if (!best) return null;
    // Use the outermost wrapper with the same box so later scaling moves the whole shape.
    let top = best, r0 = best.getBoundingClientRect();
    while (top.parentElement && top.parentElement !== canvas && !top.parentElement.contains(label)) {
      const r = top.parentElement.getBoundingClientRect();
      if (Math.abs(r.left - r0.left) > 1.5 || Math.abs(r.top - r0.top) > 1.5 || Math.abs(r.width - r0.width) > 1.5 || Math.abs(r.height - r0.height) > 1.5) break;
      top = top.parentElement;
    }
    return top;
  }
  function controlOf(p) {
    const child = p.querySelector(':scope > button, :scope > a, :scope > span[aria-disabled], :scope > input:not([type=checkbox]):not([type=radio]):not([type=hidden])');
    if (!child) return null;
    if (child.tagName !== 'INPUT' && capturedText(p) !== capturedText(child)) return null;
    if (capturedText(p).length > 48) return null;
    return child;
  }
  function snapControls(canvas) {
    if (canvas.hidden || !canvas.getBoundingClientRect().width || canvas.querySelector('.soeli-mobile-contact')) return;
    const scale = canvas.getBoundingClientRect().width / (canvas.offsetWidth || 1) || 1;
    const items = [];
    canvas.querySelectorAll('p').forEach(p => {
      const child = controlOf(p); if (!child) return;
      if (!child.dataset.soeliSnap) { if (!p.style.height) p.style.height = p.offsetHeight + 'px'; }
      child.classList.remove('soeli-snap'); child.style.cssText = child.dataset.soeliBase ?? (child.dataset.soeliBase = child.style.cssText);
      const cr = child.getBoundingClientRect(), lr = p.getBoundingClientRect();
      const shape = child.dataset.soeliSnap && p._soeliShape?.isConnected ? p._soeliShape : shapeBehind(canvas, p, cr.width > lr.width && lr.width ? lr : cr);
      if (!shape) return;
      p._soeliShape = shape; child.dataset.soeliSnap = '1';
      items.push({ p, child, shape });
    });
    // Inputs and the button next to them (newsletter rows) share one height.
    for (const field of items.filter(i => i.child.tagName === 'INPUT')) {
      const a = field.shape; a.style.scale = ''; a.style.translate = '';
      const ra = a.getBoundingClientRect();
      const other = items.find(i => i !== field && (() => { const r = i.shape.getBoundingClientRect(); return Math.abs(r.top - ra.top) < 16 && Math.abs(r.height - ra.height) < 16 && r.left >= ra.right - 4 && r.left - ra.right < 48; })());
      if (!other) continue;
      other.shape.style.scale = ''; other.shape.style.translate = '';
      const rb = other.shape.getBoundingClientRect();
      const top = Math.min(ra.top, rb.top), bottom = Math.max(ra.bottom, rb.bottom);
      for (const el of [a, other.shape]) {
        const r = el.getBoundingClientRect();
        if (Math.abs(r.top - top) < .5 && Math.abs(r.bottom - bottom) < .5) continue;
        el.style.scale = '1 ' + ((bottom - top) / r.height);
        const r2 = el.getBoundingClientRect();
        el.style.translate = '0 ' + ((top - r2.top) / scale) + 'px';
      }
    }
    for (const { p, child, shape } of items) {
      const pr = p.getBoundingClientRect(), sr = shape.getBoundingClientRect();
      child.classList.add('soeli-snap');
      if (child.tagName === 'INPUT') child.classList.add('soeli-snap-input');
      Object.assign(child.style, { left: ((sr.left - pr.left) / scale) + 'px', top: ((sr.top - pr.top) / scale) + 'px', width: (sr.width / scale) + 'px', height: (sr.height / scale) + 'px' });
      if (child.tagName === 'INPUT') continue;
      let size = parseFloat(getComputedStyle(p).fontSize) || 14, ls = parseFloat(getComputedStyle(p).letterSpacing) || 0;
      child.style.fontSize = size + 'px'; child.style.letterSpacing = ls + 'px';
      let pad = 14;
      while (child.scrollWidth > child.clientWidth + 1 && (ls > 0.3 || pad > 6 || size > 10)) {
        if (ls > 0.3) ls = Math.max(0.3, ls - 0.3); else if (pad > 6) pad -= 2; else size -= 0.5;
        child.style.fontSize = size + 'px'; child.style.letterSpacing = ls + 'px'; child.style.setProperty('padding', '0 ' + pad + 'px', 'important');
      }
    }
  }
  // A snapped button must never cover a text node: shrink the colliding text until it fits beside it.
  function declutter(canvas) {
    canvas.querySelectorAll('.soeli-snap').forEach(control => {
      const cr = control.getBoundingClientRect(); if (!cr.width) return;
      canvas.querySelectorAll('p,h1,h2,h3,h4,span').forEach(node => {
        if (node === control || node.contains(control) || control.contains(node)) return;
        if (node.closest('[data-soeli-price]')) return;
        if (node.children.length && !node.querySelector('span')) return;
        const r = node.getBoundingClientRect(); if (!r.width) return;
        const overlapX = Math.min(r.right, cr.right) - Math.max(r.left, cr.left);
        const overlapY = Math.min(r.bottom, cr.bottom) - Math.max(r.top, cr.top);
        if (overlapX <= 2 || overlapY <= 2) return;
        let size = parseFloat(getComputedStyle(node).fontSize); if (!(size > 0)) return;
        const min = Math.max(12, size * 0.6);
        node.querySelectorAll('span').forEach(s => { s.style.fontSize = 'inherit'; });
        while (size > min) {
          size -= 1; node.style.fontSize = size + 'px';
          const nr = node.getBoundingClientRect();
          const ox = Math.min(nr.right, cr.right) - Math.max(nr.left, cr.left);
          const oy = Math.min(nr.bottom, cr.bottom) - Math.max(nr.top, cr.top);
          if (ox <= 2 || oy <= 2) break;
        }
      });
    });
  }
  // Canva paints the "2 / 4 / 6 personnes" format choices as flat text over a shape.
  // Cover each one with a real toggle button bound to the card's Shopify variants.
  const PILL = /^(\d+)\s*(?:pers\.?|personnes?)$/i;
  const euro = n => (Math.round(n * 100) / 100).toLocaleString('fr-FR', { minimumFractionDigits: Number.isInteger(Math.round(n * 100) / 100) ? 0 : 2, maximumFractionDigits: 2 });
  function nearestBelow(canvas, selector, top, left, right) {
    let best = null, gap = Infinity;
    canvas.querySelectorAll(selector).forEach(el => {
      const r = el.getBoundingClientRect(); if (!r.width) return;
      const cx = r.left + r.width / 2, g = r.top - top;
      if (g < -40 || g > 500 || cx < left || cx > right || g >= gap) return;
      best = el; gap = g;
    });
    return best;
  }
  function fixPills(canvas) {
    if (canvas.hidden || !canvas.getBoundingClientRect().width || !canvas.querySelector('[data-canva-purchase]')) return;
    const cr = canvas.getBoundingClientRect();
    const scale = cr.width / (canvas.offsetWidth || 1) || 1;
    const pills = [...canvas.querySelectorAll('p')].filter(p => !p.dataset.soeliPillDone && PILL.test(capturedText(p)));
    const titles = [...canvas.querySelectorAll('[data-card^="title:"]')].map(el => ({ el, r: el.getBoundingClientRect() })).filter(t => t.r.width);
    const groups = new Map();
    for (const p of pills) {
      const pr = p.getBoundingClientRect(); if (!pr.width) continue;
      const cx = pr.left + pr.width / 2;
      const title = titles.filter(t => t.r.top < pr.top && pr.top - t.r.top < 600 && t.r.left - 40 <= cx)
        .sort((a, b) => (b.r.left - a.r.left) || (b.r.top - a.r.top))[0];
      if (!title) continue;
      const key = title.el.dataset.card.split(':')[1];
      const colRight = Math.min(...titles.filter(t => t.r.left > title.r.left + 40 && Math.abs(t.r.top - title.r.top) < 80).map(t => t.r.left - 10), cr.right);
      const label = nearestBelow(canvas, '[data-card="btn:' + key + '"]', pr.top, title.r.left - 40, colRight);
      const buy = label?.querySelector('[data-canva-purchase]'); if (!buy) continue;
      let variants; try { variants = JSON.parse(buy.dataset.productVariants); } catch { continue; }
      const n = capturedText(p).match(PILL)[1];
      const variant = variants.find(v => (v.title.match(/^\s*(\d+)/) || [])[1] === n); if (!variant) continue;
      if (!groups.has(buy)) groups.set(buy, { buy, key, title, colRight, pills: [] });
      groups.get(buy).pills.push({ p, n: Number(n), variant, selected: getComputedStyle(p.querySelector('span') || p).color === 'rgb(255, 255, 255)' });
    }
    for (const group of groups.values()) {
      const br = group.buy.getBoundingClientRect();
      group.price = nearestBelow(canvas, '[data-card="price:' + group.key + '"]', group.title.r.top, group.title.r.left - 40, group.colRight);
      group.perPerson = [...canvas.querySelectorAll('p')].find(p => {
        const r = p.getBoundingClientRect(), cx = r.left + r.width / 2;
        return /^soit .*personne$/i.test(capturedText(p)) && cx >= group.title.r.left - 40 && cx <= group.colRight && r.top > group.title.r.top && r.top < br.bottom + 160;
      }) || null;
      group.pills.sort((a, b) => a.n - b.n);
      for (const item of group.pills) {
        const { p } = item;
        const pr = p.getBoundingClientRect();
        const shape = shapeBehind(canvas, p, pr);
        const sr = shape ? shape.getBoundingClientRect() : pr;
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'soeli-pill'; button.textContent = capturedText(p);
        button.setAttribute('aria-label', 'Format ' + item.variant.title.split('—')[0].trim());
        const cs = getComputedStyle(p.querySelector('span') || p);
        Object.assign(button.style, { left: ((sr.left - cr.left) / scale) + 'px', top: ((sr.top - cr.top) / scale) + 'px', width: (sr.width / scale) + 'px', height: (sr.height / scale) + 'px', fontFamily: cs.fontFamily, fontSize: cs.fontSize, letterSpacing: cs.letterSpacing });
        if (shape) shape.style.visibility = 'hidden';
        p.style.visibility = 'hidden'; p.dataset.soeliPillDone = '1';
        button._soeli = { group, item };
        button.disabled = item.variant.available === false;
        canvas.append(button); item.button = button;
      }
      const initial = group.pills.find(i => i.selected && !i.button.disabled) || group.pills.find(i => !i.button.disabled);
      if (initial) selectPill(initial.button);
    }
  }
  function setText(el, text) {
    if (!el) return;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT); let first = true;
    while (walker.nextNode()) { const t = walker.currentNode; if (!t.textContent.trim()) continue; t.textContent = first ? text : ''; first = false; }
  }
  function selectPill(button) {
    const { group, item } = button._soeli;
    for (const other of group.pills) other.button.setAttribute('aria-pressed', other === item ? 'true' : 'false');
    group.buy.dataset.preselect = item.variant.id;
    const amount = (item.variant.title.split('—')[1] || '').trim();
    const value = parseFloat(amount.replace(/[^\d,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.'));
    if (amount && group.price) {
      group.price.dataset.soeliPrice = '';
      // Restore the captured size that declutter() shrank for the longer "À partir de" label.
      [group.price, ...group.price.querySelectorAll('*')].forEach(el => { el.style.fontSize = ''; });
      setText(group.price, amount);
      const canvas = group.buy.closest('.soeli-canva-canvas'); if (canvas) declutter(canvas);
    }
    if (value > 0) setText(group.perPerson, 'soit ' + euro(value / item.n) + ' € / personne');
  }
  let snapFrame = 0;
  const scheduleSnap = () => { cancelAnimationFrame(snapFrame); snapFrame = requestAnimationFrame(() => document.querySelectorAll('.soeli-canva-canvas').forEach(c => { fixPills(c); snapControls(c); declutter(c); })); };
  window.addEventListener('resize', scheduleSnap);
  document.fonts?.ready.then(scheduleSnap);
  // Products have no Shopify photo yet: carry the Canva card photo into the cart line.
  function cardImage(from) {
    const canvas = from.closest('.soeli-canva-canvas'); if (!canvas) return '';
    const key = from.closest('[data-card]')?.dataset.card?.split(':')[1];
    const anchor = (key && canvas.querySelector('[data-card="title:' + key + '"]')) || from;
    const ar = anchor.getBoundingClientRect(); if (!ar.width) return '';
    let best = '', bestGap = Infinity;
    canvas.querySelectorAll('img').forEach(img => {
      const r = img.getBoundingClientRect();
      if (r.width < 80 || r.height < 80 || r.right < ar.left || r.left > ar.right) return;
      const gap = ar.top - r.bottom;
      if (gap < -20 || gap > 400 || gap >= bestGap) return;
      best = img.currentSrc || img.src; bestGap = gap;
    });
    return best;
  }
  function setImage(form, url) {
    let input = form.querySelector('input[name="properties[_image]"]');
    if (!url) { input?.remove(); return; }
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[_image]'; form.append(input); }
    input.value = url.replace(/^https?:/, '');
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest?.('.soeli-product-form'); if (!form) return;
    if (form.closest('#SoeliVariantPicker')) return;
    if (!form.querySelector('input[name="properties[_image]"]')) setImage(form, cardImage(form));
  }, true);
  function run() {
    document.querySelectorAll('.soeli-canva-canvas').forEach(canvas => { fixContact(canvas); fixCards(canvas); fixPills(canvas); fitText(canvas); snapControls(canvas); declutter(canvas); });
    document.querySelectorAll('a[href="/pages/page-notre-histoire"]').forEach(a => a.href = '/pages/notre-histoire');
    document.querySelectorAll('a[href="/pages/onglet-ptisseries"]').forEach(a => a.href = '/pages/onglet-patisseries');
    document.querySelectorAll('.soeli-canva-canvas p').forEach(p => {
      if (/Maison Sol[ée]i|Maison Sol[ée]a/i.test(p.textContent)) {
        const walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) walker.currentNode.textContent = walker.currentNode.textContent.replace(/Maison Sol[ée]i|Maison Sol[ée]a/gi, 'SOELI');
      }
    });
    document.querySelectorAll('details p').forEach(p => {
      const walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) { const t = walker.currentNode; const c = t.textContent.replace(/\s*Questions fréquentes\.\s*(?:-\s*)+$/, '').replace(/(?:\s-){3,}\s*$/, ''); if (c !== t.textContent) t.textContent = c; }
    });
    document.querySelectorAll('.soeli-canva-frame').forEach(frame => {
      const active = frame.querySelector('[data-canva-width]:not([hidden])');
      if (active) frame.style.height = (active.scrollHeight * frame.clientWidth / Number(active.dataset.canvaWidth)) + 'px';
    });
    window.dispatchEvent(new Event('resize'));
  }
  document.addEventListener('click', event => {
    const pill = event.target.closest('.soeli-pill'); if (!pill || !pill._soeli) return;
    event.preventDefault(); selectPill(pill);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-canva-purchase]'); if (!button || button.disabled) return;
    event.preventDefault();
    let variants; try { variants = JSON.parse(button.dataset.productVariants); } catch { return; }
    variants = variants.filter(v => v.available !== false);
    if (!variants.length) return;
    let dialog = document.getElementById('SoeliVariantPicker');
    if (!dialog) {
      dialog = document.createElement('dialog'); dialog.id = 'SoeliVariantPicker'; dialog.className = 'soeli-dialog soeli-variant-picker';
      dialog.innerHTML = '<div class="soeli-dialog-head"><h2></h2><button type="button" class="soeli-icon" aria-label="Fermer" data-dialog-close>×</button></div><form class="soeli-product-form"><label>Format<select name="id" aria-label="Format"></select></label><input type="hidden" name="quantity" value="1"><button type="submit">Ajouter au panier</button><p data-product-error role="alert"></p></form>';
      document.body.append(dialog);
    }
    dialog.querySelector('h2').textContent = button.dataset.productTitle;
    const select = dialog.querySelector('select'); select.replaceChildren();
    for (const v of variants) select.add(new Option(v.title, v.id));
    if (button.dataset.preselect) select.value = button.dataset.preselect;
    dialog.querySelector('[data-product-error]').textContent = '';
    setImage(dialog.querySelector('form'), cardImage(button));
    if (variants.length > 1 && !(button.dataset.preselect && variants.some(v => v.id === button.dataset.preselect))) dialog.showModal();
    else dialog.querySelector('form').requestSubmit();
  });
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('load', run);
  run();
})();